export const VALID_PHONE_LENGTH = 11;
